import React, { useEffect, useState } from 'react'
import { Skeleton } from 'antd'
import { BaseServices } from '../../../helpers/baseServices'
import { global_variables } from '../../../helpers/globalVariables'
import { VscBook } from 'react-icons/vsc'
import { useGeneralContext } from '../../../context/generalContext'

const PublishedBooks = () => {

    const { reFetch } = useGeneralContext()
    const [isFetching, setIsFetching] = useState(true)
    const [pubBooks, setPubBooks] = useState<any>(0)

    //onload
    useEffect(() => {
        const getPubBooks = async () => {
            setIsFetching(true)

            try {
                const response = await BaseServices.get(`${global_variables.list_audio_book}?limit=1&type=Book&status=Published`)
                // console.log("pubBooks:", response?.data)
                setPubBooks(response?.data?.count)
                setIsFetching(false)
            } catch (error) {
                console.log(error)
            }
        }

        getPubBooks()
    }, [reFetch])


    return (
        <>
            {
                isFetching ?
                    <div className="w-full border border-gray-300 p-5 rounded shadow-sm">
                        <div>
                            <Skeleton active paragraph={{ rows: 2 }} />
                        </div>
                    </div>
                    :
                    <div className="w-full border border-gray-300 p-5 rounded shadow-sm flex justify-between items-center">
                        <div>
                            <p className='text-[18px] font-[500]'>Published Books</p>

                            <p className='text-[24px] font-[600] mt-3'>
                                {pubBooks}
                            </p>
                        </div>

                        <div>
                            <VscBook className='h-10 w-10' />
                        </div>
                    </div>
            }
        </>
    )
}

export default PublishedBooks
